/**
 * Device-токен игрока (Фаза 13, Эпик A2, план §A2): localStorage
 * `kikayoo:ptoken:<pin>` — ключ по PIN сессии.
 *
 * Токен выдаёт сервер (`joined.payload.playerToken`, только при создании нового
 * слота/legacy-resume) — здесь он переживает F5/закрытие вкладки (в отличие от
 * sessionStorage-записи activeSession, живущей с вкладкой) и отправляется в
 * КАЖДОМ `join` (первичный вход и автореконнекты) — тогда обрыв связи возвращает
 * игрока в тот же слот даже после rename, а не по нику.
 *
 * Жизненный цикл: запись при `joined.playerToken`; очистка по `finished`
 * (сессия закончилась — токен мёртв, строки players_in_session удалены).
 * Ошибки quota/private-mode глушатся — без localStorage игра работает как
 * раньше (resume по нику, legacy-режим сервера).
 */
const PREFIX = 'kikayoo:ptoken:';

/** Полный ключ хранения токена сессии с данным PIN. */
function tokenKey(pin: string): string {
  return `${PREFIX}${pin}`;
}

/** Сохранить device-токен игрока для сессии с данным PIN (из joined.playerToken). */
export function savePlayerToken(pin: string, token: string): void {
  if (!token) return;
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return;
  try {
    window.localStorage.setItem(tokenKey(pin), token);
  } catch {
    // private mode / quota — resume по токену не сработает, сервер примет join
    // с ником (legacy-режим). Молча пропускаем, как activeSession.
  }
}

/**
 * Прочитать device-токен сессии с данным PIN; undefined — токена нет
 * (первый вход с этого устройства). Читается на момент отправки join.
 */
export function loadPlayerToken(pin: string): string | undefined {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return undefined;
  try {
    const value = window.localStorage.getItem(tokenKey(pin));
    return value ? value : undefined;
  } catch {
    return undefined;
  }
}

/** Стереть device-токен сессии (по `finished` — сессия завершена, токен мёртв). */
export function clearPlayerToken(pin: string): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return;
  try {
    window.localStorage.removeItem(tokenKey(pin));
  } catch {
    // ignore
  }
}
